<template>
    <div>
        <div class="help">
            <div class="help-top">
                <div>
                    <span style="font-size: 25px ; color: #fff">帮助中心</span>
                    <input type="text" placeholder="请输入关键词进行搜索">
                    <mu-icon size="30" value="search" color="grey900" style="position: absolute;top: 12px; right: 45px;"></mu-icon>
                </div>
             </div>
        </div>
        <router-view/>
    </div>
</template>
<script>
    export default {
        name: 'help'
    }
</script>
<style scoped>
    .help{
        float: left;
        width: 100%;
        height: 270px;
        background: url(../../assets/helpBanner.png) center no-repeat;
    }
    .help-top{
        width: 732px;
        position: relative;
        top: 120px;
        left: 50%;
        margin-left: -366px;
    }
    .help-top input{
        height: 50px;
        line-height: 50px;
        margin-left: 10px;
        font-size: 14px;
        text-indent: 20px;
        -webkit-box-shadow: none;
        box-shadow: none;
        outline: none;
        border: none;
        width: 540px;
        border-radius: 15px;
    }
    .help-mid{
        background: #f7f8fa;
    }

    .help-mid>ul{
        padding: 50px 0;
        width: 1233px;
        height: 300px;
        margin: 0 auto;
        text-align: center;
        list-style: none;
        overflow: hidden;
    }
    .help-mid>ul>li{
        float: left;
        margin-right: 20px;
        padding: 40px 0 28px;
        -webkit-box-shadow: 0px 0px 16px #eaeaea;
        box-shadow: 0px 0px 16px #eaeaea;
        -webkit-transition: all 0.3s;
        transition: all 0.3s;
        background: #fff;
        width: 285px;
        height: 196px;
        border-radius: 4px;
        font-size: 14px;
        line-height: 30px;
        color: #999;
        position: relative;
        top: 0;
    }
    .help-mid>ul>li:hover{
        top: -20px;
    }
    h3{
        line-height: 40px;
        font-size: 16px;
        color: #333;
    }
    ul{
        list-style: none;
    }

</style>


// WEBPACK FOOTER //
// src/components/help/help.vue